import { render } from "./UserPoems.vue?vue&type=template&id=f3348f30"
import script from "./UserPoems.vue?vue&type=script&lang=js"
export * from "./UserPoems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__